import { makeObservable, observable, runInAction } from 'mobx';

import { MAX_API_PAGE_SIZE } from '~constants/consts';
import { Job } from '~hooks/useJob/models';
import { GetJobsByCompanyIdParams } from '~hooks/useJob/useJob';
import { DEFAULT_INCLUDED_JOB_STATES } from '~pages/Approvals/Files/constants';
import { Pagination } from '~services/pagination';

type ApproveJobsDatagridFilters = NonNullable<GetJobsByCompanyIdParams['filters']>;

const DEFAULT_PAGINATION: Pagination = { limit: MAX_API_PAGE_SIZE, page: 1 };
const APPROVE_JOBS_DATAGRID_FILTERS_INITIAL_STATE: ApproveJobsDatagridFilters = {
  jobStates: DEFAULT_INCLUDED_JOB_STATES,
};

export default class ApproveJobsStore {
  filters: ApproveJobsDatagridFilters;
  isLoadingJobs: boolean = true;
  isUpdatingJob: Record<string, boolean> = {};
  jobs: Job[] = [];
  pagination?: Pagination = DEFAULT_PAGINATION;

  constructor() {
    makeObservable(this, {
      filters: observable,
      isLoadingJobs: observable,
      isUpdatingJob: observable,
      jobs: observable,
      pagination: observable,
    });

    this.filters = { ...APPROVE_JOBS_DATAGRID_FILTERS_INITIAL_STATE };
  }

  clearApproveJobsDatagridFilters() {
    runInAction(() => {
      this.filters = { ...APPROVE_JOBS_DATAGRID_FILTERS_INITIAL_STATE };
    });
  }

  fetchJobsStart() {
    runInAction(() => {
      this.isLoadingJobs = true;
    });
  }

  fetchJobsSuccess(jobs: Job[], pagination?: Pagination) {
    runInAction(() => {
      this.isLoadingJobs = false;
      this.jobs = jobs;
      this.pagination = pagination;
    });
  }

  setApproveJobsDatagridFilters(filters: Partial<ApproveJobsDatagridFilters>) {
    runInAction(() => {
      this.filters = { ...this.filters, ...filters };
    });
  }

  updateJobStart(jobId: string) {
    runInAction(() => {
      this.isUpdatingJob[jobId] = true;
    });
  }

  updateJobSuccess(job: Job) {
    runInAction(() => {
      this.isUpdatingJob[job.id] = false;
      this.upsertJob(job);
    });
  }

  upsertJob(job: Job) {
    runInAction(() => {
      const index = this.jobs.findIndex(({ id }) => id === job.id);

      if (index > -1) {
        this.jobs[index] = job;
      } else {
        this.jobs.push(job);
      }

      this.jobs = [...this.jobs];
    });
  }
}
